import { useEffect, useState } from 'react';
import CertificateDetail from './CertificateDetail';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatCompletionDate } from './utils';

const CertificatesPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCertificate, setSelectedCertificate] = useState<any | null>(null);
  const [certificateCourses, setCertificateCourses] = useState<any>([]);
  const [profileData,setProfileData] = useState<any>(location.state.profileData)
  
  useEffect(() => {
    const courseData = location.state.courseData;
    const filteredCourseData = courseData?.filter((course : any) => course?.status_obj[0]?.status === "completed");
    setCertificateCourses(filteredCourseData);
  }
  , []);

  if (selectedCertificate) {
    return <CertificateDetail profileData={profileData} certificateData={selectedCertificate} onBack={() => setSelectedCertificate(null)} />;
  }

  return (
    <div className="certificates-page">
      <div className="certificates-page-title">
        <ArrowLeftOutlined 
          className="back-arrow"
          onClick={() => navigate("/learning")} 
        /> 
        <span>My Certificates</span>
      </div>
      <div className="certificates-grid">
        {certificateCourses?.map((cert) => (
          <div key={cert.id} className="certificates-card">
            <div className="content-area">
              <h3 className="topic-title">{cert.title}</h3>
              <div className="topic-desc">{cert.description}</div>
            </div>
            <div className="certificates-card-bottom">

              <div className="completion-date">
                Completed on: {formatCompletionDate(cert.status_obj[0]?.completed_date)}
              </div>
              <div className="view-certificate-text" onClick={() => setSelectedCertificate(cert)}>View Certificate</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificatesPage;